import React from 'react';
import PropTypes from 'prop-types';

import t from '../../lib/I18n';

import OnEnterTrigger from '../general/OnEnterTrigger';

export default function NotificationListItem ({ notification }) {
    return (
        <OnEnterTrigger element="li"
            role="button"
            onClick={ notification.onClick }
            className="notification-list__item">
            <table>
                <tbody>
                    <tr>
                        <td>
                            <h2 className="notification-list__item__title">{ t(notification.title) }</h2>
                            <span className="notification-list__item__description">
                                { t(notification.description) }
                            </span>
                        </td>
                        <td width="58">
                            <button className="notification-list__item__cta" tabIndex="-1" onClick={ notification.onClick } aria-hidden="true">
                                { t('global.go') }
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <span className="sr-only">
                . { t('global.clickForMoreInfo') }
            </span>
        </OnEnterTrigger>
    );
}

NotificationListItem.propTypes = {
    notification: PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired
    }).isRequired
};



// WEBPACK FOOTER //
// ./src/components/notificationCentre/ListItem.js